import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Paper,
  Grid,
} from '@mui/material'
import I18n from 'i18n-js'
import { useState } from 'react'

import RequestCampaignsDialog from '@src/components/content/RequestCampaignsDialog'
import { useRefinerSurvey } from '@src/lib/useRefinerSurvey'

interface SubmitAnIdeaDialogProps {
  open: boolean
  onClose: () => void
}

const SubmitAnIdeaDialog: React.FC<
  React.PropsWithChildren<SubmitAnIdeaDialogProps>
> = ({ open, onClose }) => {
  const { refiner } = useRefinerSurvey()
  const [value, setValue] = useState('Feature/Functionality Suggestion')
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value)
  }

  const [isRequestDialogOpen, setIsRequestDialogOpen] = useState(false)

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          setValue('Feature/Functionality Suggestion')
          onClose()
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{I18n.t('nav.excitedToHearFromYou')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{I18n.t('nav.whatTypeOfIdea')}</DialogContentText>
          <FormControl>
            <RadioGroup value={value} onChange={handleChange}>
              <Grid container spacing={5}>
                <Grid item>
                  <FormControlLabel
                    value="Feature/Functionality Suggestion"
                    control={<Radio />}
                    label={
                      <Paper elevation={3}>
                        <Box padding={4}>
                          <Typography
                            variant="h6"
                            style={{ whiteSpace: 'nowrap', width: '300px' }}
                          >
                            {I18n.t('nav.featureSuggestion')}
                          </Typography>

                          <Typography color="textSecondary">
                            {I18n.t('nav.featureSuggestionDescription')}
                          </Typography>
                        </Box>
                      </Paper>
                    }
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    value="Content Suggestion"
                    control={<Radio />}
                    label={
                      <Paper elevation={3}>
                        <Box padding={4}>
                          <Typography
                            variant="h6"
                            style={{ whiteSpace: 'nowrap', width: '300px' }}
                          >
                            {I18n.t('nav.contentSuggestion')}
                          </Typography>

                          <Typography color="textSecondary">
                            {I18n.t('nav.contentSuggestionDescription')}
                          </Typography>
                        </Box>
                      </Paper>
                    }
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => onClose()}>
            {I18n.t('shared.close')}
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            onClick={() => {
              if (value === 'Feature/Functionality Suggestion') {
                refiner('showForm', 'product-feature-research')
              } else if (value === 'Content Suggestion') {
                setIsRequestDialogOpen(true)
              }
              onClose()
            }}
          >
            {I18n.t('nav.next')}
          </Button>
        </DialogActions>
      </Dialog>
      {(
        <RequestCampaignsDialog
          open={isRequestDialogOpen}
          onClose={() => setIsRequestDialogOpen(false)}
        />
      )}
    </>
  )
}

export default SubmitAnIdeaDialog
